import { AlignItems, Box, Button, Display, FlexDirection } from '@gousto-internal/citrus-react'
import React from 'react'
import { Surcharge } from '../Surcharge/Surcharge'

type SimpleAddButtonProps = {
  disabled: boolean
  isNegativeSurcharge?: boolean
  onClick: (isFirstInBatchOfSameRecipes: boolean) => void
  surchargeLabel: string | null
}

export const SimpleAddButton = ({
  disabled,
  isNegativeSurcharge,
  onClick,
  surchargeLabel,
}: SimpleAddButtonProps) => {
  return (
    <Button onClick={() => onClick(true)} disabled={disabled} width="100%">
      <Box
        alignItems={AlignItems.Center}
        display={Display.Flex}
        flexDirection={[FlexDirection.Column, FlexDirection.Row]}
        gap={[0, 2]}
      >
        Add recipe
        <Surcharge label={surchargeLabel} variant={isNegativeSurcharge ? 'value' : 'dark'} />
      </Box>
    </Button>
  )
}
